export default "__VITE_ASSET__Bnl1LVNQ__"